import * as React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import SeoType from "../types/seo.type"

const SEO = ({ isLpPage, data, impressionLink }: SeoType) => {
  const { pathname } = useLocation()
  const { site } = useStaticQuery(query)
  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    twitterUsername,
  } = site.siteMetadata

  const seo = {
    title: data.title || defaultTitle,
    description: data.description || defaultDescription,
    image: data.socialImage?.url || `${siteUrl}${defaultImage}`,
    url: `${siteUrl}${pathname}`,
  }

  const selfUrl = typeof window !== "undefined" ? window.location.href : ""

  const noFollow = data["no_follow"] ? true : false
  const noIndex = data["no_index"] ? true : false
  const follow = data["follow"] ? true : false

  return (
    <>
      {/* <script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/4e6d2e47-7ef6-461f-b3e1-350aee1a73ae/OtAutoBlock.js"
      /> */}
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="4e6d2e47-7ef6-461f-b3e1-350aee1a73ae"
      />
      <script>
        {`
          function OptanonWrapper() { }
        `}
      </script>
      {!!impressionLink && (
        <img className="hidden" src={impressionLink} alt="impression-Link" />
      )}
      <Helmet title={seo.title} titleTemplate={titleTemplate}>
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />

        <link
          rel="canonical"
          href={data.canonical ? data.canonical : selfUrl}
        />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />

        {noIndex && !noFollow && !follow && (
          <meta name="robots" content="noindex" />
        )}
        {noIndex && follow && <meta name="robots" content="noindex, follow" />}
        {noIndex && noFollow && (
          <meta name="robots" content="noindex, nofollow" />
        )}
        {!noIndex && noFollow && <meta name="robots" content="nofollow" />}

        {seo.url && <meta property="og:url" content={seo.url} />}
        {seo.title && <meta property="og:title" content={seo.title} />}
        {seo.description && (
          <meta property="og:description" content={seo.description} />
        )}
        {seo.image && <meta property="og:image" content={seo.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        {twitterUsername && (
          <meta name="twitter:creator" content={twitterUsername} />
        )}
        {seo.title && <meta name="twitter:title" content={seo.title} />}
        {seo.description && (
          <meta name="twitter:description" content={seo.description} />
        )}
        {seo.image && <meta name="twitter:image" content={seo.image} />}

        {data.schemaJson && (
          <script type="application/ld+json">
            {data.schemaJson.schemaJson}
          </script>
        )}
        {isLpPage && (
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-953467087"
          />
        )}
        {isLpPage && (
          <script>
            {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-953467087');
              `}
          </script>
        )}
        {isLpPage && (
          <script>
            {`
              function gtag_report_conversion(url) {
                var callback = function () {
                  if (typeof(url) != 'undefined') {
                    window.location = url;
                  }
                };
                gtag('event', 'conversion', {
                    'send_to': 'AW-953467087/AvlWCPnLwKsYEM-B08YD',
                    'event_callback': callback
                });
                return false;
              }
            `}
          </script>
        )}
      </Helmet>
    </>
  );
}
export default SEO

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`
